import { T } from "../../util/t";
import { Typography, Box } from "@mui/material";
import { PriceDescriptions } from "../registration/selectOptionsField/PriceDescriptions";
import { Event } from "graphql/generated/types";
import { useFeatureFlags } from "components/providers/featureFlags/useFeatureFlags";
import { RegistrationDescription } from "components/routes/events/id/registration/RegistrationDescription";

type EventProps = Pick<
    Event,
    | "status"
    | "scheduledEntryOpen"
    | "scheduledEntryClose"
    | "registrationOptions"
    | "eventDivisions"
    | "paymentOptions"
    | "location"
>;

const showRegistrationDetails = (event: EventProps) => {
    const showRegistrationUpcoming =
        event.status === "upcoming" && event.scheduledEntryClose;
    const showRegistrationScheduled =
        event.status === "scheduled" &&
        (event.scheduledEntryOpen || event.scheduledEntryClose);
    return showRegistrationUpcoming || showRegistrationScheduled;
};

const showPaymentDetails = (event: EventProps) => {
    const paymentOptions = event.paymentOptions;
    return (
        event.status === "upcoming" &&
        paymentOptions &&
        (paymentOptions.defaultDivisionPrice != null ||
            paymentOptions.extraDivisionPrice != null ||
            paymentOptions.divisions ||
            paymentOptions.familyTotal)
    );
};

export const EntryDetails: React.FC<{ event: EventProps }> = ({ event }) => {
    const regoDetailsEnabled = useFeatureFlags("Rego details");

    const showRegistration = showRegistrationDetails(event);
    const showPayment = showPaymentDetails(event);

    if (!regoDetailsEnabled) {
        if (!showPayment) return null;

        return (
            <Box component="section" mt={2} mb={3}>
                <Typography variant="subtitle3">
                    <T>Entry details</T>
                </Typography>
                <Typography variant="caption" component="h2" mt={1}>
                    <PriceDescriptions
                        registrationOptions={event.registrationOptions}
                        paymentOptions={event.paymentOptions}
                        totalDivisions={event.eventDivisions.length}
                    />
                </Typography>
            </Box>
        );
    }

    if (!showRegistration && !showPayment) return null;

    return (
        <Box component="section" mt={2} mb={3}>
            <Typography variant="subtitle3">
                <T>Entry details</T>
            </Typography>
            <Typography variant="caption" component="h2" mt={1}>
                {showRegistration && (
                    <RegistrationDescription
                        scheduledEntryOpen={event.scheduledEntryOpen}
                        scheduledEntryClose={event.scheduledEntryClose}
                        location={event.location}
                    />
                )}
                {showPayment && (
                    <PriceDescriptions
                        registrationOptions={event.registrationOptions}
                        paymentOptions={event.paymentOptions}
                        totalDivisions={event.eventDivisions.length}
                    />
                )}
            </Typography>
        </Box>
    );
};
